import Icon from 'veui/components/Icon'
import { IconGateway } from 'dls-icons-vue'

Icon.register('gateway', IconGateway)
